import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

const HEADER_ID = 'pdf--edit-living-balance-sheet-modal--header';

const NAMES = [
  'Net Worth Summary',
  'Estate Summary',
  'Summary of Trusts & Other Entities',
  'Net Worth Summary (Legacy)',
  'Net Worth Detailed (Legacy)',
];

interface Props {
  data: Record<string, boolean>;
  onClose(): void;
  onSave(param: { [key: string]: boolean }): void;
}

export const LivingBalanceSheet = ({ data, onClose, onSave: baseOnSave }: Props) => {
  const [temporaryData, setTemporaryData] = React.useState<Record<string, boolean>>(data);

  const onSave = () => {
    const values = Object.entries(temporaryData).reduce<{ [key: string]: boolean }>(
      (acc, [name, value]) => ({
        ...acc,
        ...{ [name]: value },
      }),
      {},
    );

    baseOnSave(values);
    onClose();
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: HEADER_ID }}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader as="h2" id={HEADER_ID}>
        Edit Net Worth Reports
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Text as="p" color="neutral.500">
          Select the pages you would like to show in the PDF
        </Text>

        {Object.entries(temporaryData).map(([name, value], parentIndex) => {
          return (
            <VisualPicker
              key={name}
              variant="checkbox"
              label={NAMES[parentIndex]}
              checked={value}
              onChange={() => {
                setTemporaryData(state => {
                  return { ...state, [name]: !value };
                });
              }}
              mt="8"
            />
          );
        })}
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button ml="8" onClick={onSave}>
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
